import Vue from "vue";

export default {
  mFinishedLoading(state) {
    state.loadingapp = false;
  },
  mShowLongLoader(state, payload) {
    state.longloader.message = payload;
    state.longloader.show = true;
  },
  mHideLongLoader(state) {
    state.longloader.show = false;
    state.longloader.message = "";
  },
  mShowErrorMessage(state, payload) {
    state.errormessage = payload;
    setTimeout(() => {
      state.errormessage = "";
    }, 10000);
  },
  mShowInfoMessage(state, payload) {
    state.infomessage = payload;
    setTimeout(() => {
      state.infomessage = "";
    }, 6000);
  },
  mShowWarningMessage(state, payload) {
    state.warningmessage = {};
    state.warningmessage.deviceId = payload.deviceId;
    state.warningmessage.data = payload.data;
    setTimeout(() => {
      state.warningmessage = undefined;
    }, 6000);
  },
  mLogin(state, payload) {
    state.user = payload.user;
    Vue.$log.debug("mLogin: ", payload.user);
    Vue.$log.debug("mLogin: ", payload.authtoken);
    Vue.axios.defaults.headers.post["X-TONEGENERATOR-AUTH"] = payload.authtoken; // <-- axios bug prevention ("common" headers are sometimes not added to POST requests)
    Vue.axios.defaults.headers.common["X-TONEGENERATOR-AUTH"] = payload.authtoken;
    Vue.$auth(payload.authtoken);
  },
  mLogout(state) {
    Vue.$logout();
    state.user = undefined;
    state.baseDataLoaded = false;
    if (state.iotSignalR.isConnected)
      Vue.$stopIoTSignalr();
  },

  mLanguage(state, payload) {
    state.languages = payload;
  },
  mUserLanguage(state, payload) {
    state.user.lang = payload;
  },
  mAzureMapKey(state, payload) {
    state.azureMapKey = payload
  },

  mDevices(state, payload) {
    state.devices = payload;
  },
  mCurrentDevice(state, payload) {
    state.currentDevice = payload;
  },
  mKpi(state, payload) {
    state.kpis = payload;
  },
  mCurrentDeviceHistoricalData(state, payload) {
    Vue.set(state.currentDeviceHistoricalData, payload.kpi, payload.data)
  },
  mCurrentDeviceAlarmData(state, payload) {
    state.currentDeviceAlarmData = payload;
  },
  mCurrentDevicePir(state, payload) {
    state.currentDevicePir = payload;
  },

  mAdminTranslations(state, payload) {
    state.admin.translations = payload;
  },
  mAdminUsers(state, payload) {
    state.admin.users = payload;
  },
  mAdminContacts(state, payload) {
    state.admin.contacts = payload;
  },

  mIoTSignalRConnectionOpen(state, connection) {
    state.iotSignalR.hubConnection = connection;
    state.iotSignalR.isConnected = true;
  },
  mIoTSignalRConnectionClose(state) {
    state.iotSignalR.hubConnection = null;
    state.iotSignalR.isConnected = false;
    state.iotSignalR.deviceData = {};
  },
  mIoTSignalRSensors(state, payload) {
    let deviceId = payload.deviceId
    let data = payload.data

    if (state.devices[deviceId] !== undefined) {
      let devData = state.devices[deviceId].sensors
      devData["ambient"] = data.ambient;
      devData["accel"] = data.acceleration;
      if (data.position)
        devData["gps"] = data.position;

      Vue.set(state.devices[deviceId], "sensors", devData);
    }
    else {
      let devData = {deviceId: { sensors: {} }}
      devData.sensors["ambient"] = data.ambient;
      devData.sensors["accel"] = data.acceleration;
      if (data.position)
        devData["gps"] = data.position;

      Vue.set(state.devices, "deviceId", devData);
    }

    Vue.set(state.devices[deviceId], "timestamp", payload.timestamp);

    if (state.currentDevice != undefined && state.currentDevice.deviceId == deviceId) {
      let currDevData = state.currentDevice.sensors
      currDevData["ambient"] = data.ambient;
      currDevData["accel"] = data.acceleration;
      if (data.position)
        currDevData["gps"] = data.position;

      Vue.set(state.currentDevice, "sensors", currDevData);
      Vue.set(state.currentDevice, "timestamp", payload.timestamp);
    }
  },
  mIoTSignalRSae(state, payload) {
    let deviceId = payload.deviceId
    let data = payload.data

    if (state.devices[deviceId] !== undefined) {
      //let devData = state.devices[deviceId].sae
      //devData["sae"] = data;

      Vue.set(state.devices[deviceId], "sae", data);
    }
    else {
      let devData = {deviceId: { sae: {} }}
      devData["sae"] = data;

      Vue.set(state.devices, "deviceId", devData);
    }

    Vue.set(state.devices[deviceId], "timestamp", payload.timestamp);

    if (state.currentDevice != undefined && state.currentDevice.deviceId == deviceId) {
      let currDevData = state.currentDevice
      currDevData["sae"] = data;

      Vue.set(state, "currentDevice", currDevData);
      Vue.set(state.currentDevice, "timestamp", payload.timestamp);
    }
  },
  mIoTSignalRKeepalive(state, payload) {
    let deviceId = payload.deviceId

    Vue.set(state.devices[deviceId], "timestamp", payload.timestamp);
    Vue.set(state.devices[deviceId], "uptime", payload.data)

    if (state.currentDevice != undefined && state.currentDevice.deviceId == deviceId) {
      Vue.set(state.currentDevice, "timestamp", payload.timestamp);
      Vue.set(state.currentDevice, "uptime", payload.data);
    }
  },
  mIotSignalRAutomaticSnapshot(state, payload) {
    let deviceId = payload.deviceId
    let data = payload.data

    if (state.currentDevice != undefined && state.currentDevice.deviceId == deviceId) {
      Vue.set(state.currentDevice, "automaticSnapshots", data);
    }
  },

  mUserSignalRConnectionOpen(state, connection) {
    state.userSignalR.hubConnection = connection;
    state.userSignalR.isConnected = true;
  },
  mUserSignalRConnectionClose(state) {
    state.userSignalR.hubConnection = null;
    state.userSignalR.isConnected = false;
    state.userSignalR.devices = {};
  },
  mUserSignalRDeviceUsers(state, payload) {
    Vue.set(state.userSignalR, "devices", payload)
  },

};
